// RBAC do painel da plataforma — papéis, rótulos e nomes das permissões finas.
// As strings de permissão têm de bater certo com as que o backend devolve em
// `PlatformAdmin.permissoes` (união dos papéis do admin autenticado).

export type PlatformRole = 'ADMIN' | 'FINANCE' | 'SUPPORT'

export const PLATFORM_ROLES: PlatformRole[] = ['ADMIN', 'FINANCE', 'SUPPORT']

/** Fallback local; o catálogo `GET /platform-admins/roles` traz o `rotulo` oficial. */
export const PLATFORM_ROLE_LABEL: Record<PlatformRole, string> = {
    ADMIN: 'Administrador',
    FINANCE: 'Financeiro',
    SUPPORT: 'Suporte',
}

/** Permissões finas (nomes tal como chegam em `permissoes`). */
export const PERM = {
    TENANTS_MANAGE: 'PLATAFORMA_TENANTS_MANAGE',
    ADMINS_MANAGE: 'PLATAFORMA_ADMINS_MANAGE',
    SETTINGS_MANAGE: 'PLATAFORMA_SETTINGS_MANAGE',
    PLANOS_MANAGE: 'PLATAFORMA_PLANOS_MANAGE',
    SUBSCRICOES_MANAGE: 'PLATAFORMA_SUBSCRICOES_MANAGE',
    FATURACAO_MANAGE: 'PLATAFORMA_FATURACAO_MANAGE',
    SUPORTE_MANAGE: 'PLATAFORMA_SUPORTE_MANAGE',
} as const

/** Item do catálogo `GET /api/admin/platform-admins/roles` — popula o selector. */
export interface PlatformRoleInfo {
    role: PlatformRole
    rotulo: string
    descricao: string
    permissoes: string[]
}

export function rotuloPapel(role: PlatformRole, catalogo?: PlatformRoleInfo[]): string {
    return catalogo?.find((c) => c.role === role)?.rotulo ?? PLATFORM_ROLE_LABEL[role] ?? role
}
